import { LineHeight } from './lineHeight';

export * from './lineHeight';

export default LineHeight;
